<template>
    <a-drawer class="preview-box" @close="close" :visible.sync="visible" width="600px">
        <div class="wrapper">
            <div class="header">
                <div class="title">{{ detail.title }}</div>
                <div class="summary">{{ detail.summary }}</div>
            </div>
            <div class="content">
                <div class="qa-box">
                    <div class="qa-item" v-for="(item,index) in detail.questions" :key="item.id">
                        <!-- 序号 -->
                        <div class="qa-title">{{ index+1 }}、{{ item.title }}</div>
                        <div class="qa-text" v-if="item.type == 'text'">
                            
                        </div>
                        <template v-else>
                            <div class="qa-options">
                                <!-- 选项序号ABCDEFG -->
                                <div class="qa-option" v-for="(option,subIdx) in item.options" :key="option.id">
                                    {{ String.fromCharCode(65+subIdx) }}、{{ option.title }}
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </a-drawer>
</template>

<script>
import api from '@/repo/api';
export default {
    name: 'preview',
    data() {
        return {
            visible: false,
            detail: {},
        }
    },
    mounted() {

    },
    methods: {
        getDetail(id) {
            this.$loading.show();
            api.get('/ast-qa/detail', { id }, res => {
                if (res.code == 0) {
                    this.detail = res.data || {};
                    this.visible = true;
                }
                this.$loading.hide();
                this.$forceUpdate()
            })
        },
        close() {
            this.visible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-box {
    /deep/ .ant-drawer-body {
        padding: 0;
    }
}

.header {
    padding: 20px 32px;

    .title {
        color: #333333;
        font-size: 20px;
        font-weight: bold;
    }
    .summary {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        margin-top: 12px;
        white-space: pre-line;
    }
}

.content {
    padding: 20px 32px;

    .qa-box {
        margin-bottom: 24px;

        .qa-item {
            margin-bottom: 24px;

            .qa-title {
                font-size: 16px;
                color: #000000;
                line-height: 20px;
            }

            .qa-text {
                width: 300px;
                height: 40px;
                border: 1px solid #000000;
                margin-left: 26px;
                margin-top: 12px;
            }

            .qa-options {
                padding-left: 26px;
                margin-top: 12px;
                .qa-option {
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                }
            }
        }
    }
}
</style>
